import React from "react";
import Seo from "@/components/site/Seo";
import Band, { Eyebrow } from "@/components/site/Band";

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-display text-2xl text-spruce mb-3">{title}</h2>
    <div className="space-y-3 text-base text-ink/85 leading-relaxed">{children}</div>
  </div>
);

export default function Privacy() {
  return (
    <>
      <Seo
        title="Privacy"
        description="How Health and More handles the practice-level business information you send. We collect no patient data and use cookie-free analytics."
        path="/privacy"
      />
      <Band tone="spruce">
        <Eyebrow>Privacy</Eyebrow>
        <h1 className="font-display text-4xl sm:text-5xl leading-[1.03] max-w-3xl">Privacy</h1>
      </Band>
      <Band tone="bone">
        <div className="max-w-prose">
          <Section title="What we collect">
            <p>
              Through this site we collect only practice-level business information you choose to send us:
              practice name, specialty, your contact details, and figures like panel size or annual
              specialty drug spend. We do not collect patient data through any form on this site, and we
              ask you not to send any.
            </p>
          </Section>
          <Section title="Analytics">
            <p>
              We use privacy-respecting, cookie-free analytics. We count page views to understand which
              pages are useful. We do not set advertising cookies, we do not track you across other sites,
              and there is nothing here that requires a consent banner.
            </p>
          </Section>
          <Section title="How we use your information">
            <p>
              We use what you send to respond to your inquiry and to determine whether a program fits your
              practice. We store submissions in our own systems and share them only with the team working
              on your inquiry.
            </p>
          </Section>
          <Section title="Your choices">
            <p>
              You can ask us to update or delete the information you sent at any time by contacting us
              through the details on the contact page.
            </p>
          </Section>
          <p className="text-sm text-sage mt-8">
            This page describes our practices in plain language and is not legal advice.
          </p>
        </div>
      </Band>
    </>
  );
}
